<div
  class="ui-selfie-capture"
  [class.ui-selfie-capture--disabled]="disabled()"
  [class.ui-selfie-capture--invalid]="invalid()"
  [class.ui-selfie-capture--has-preview]="hasPreview()"
>
  <div class="ui-selfie-capture__header">
    <label class="ui-selfie-capture__label" [attr.for]="inputId()">
      {{ label() }}
    </label>
    @if (showRequirement()) {
      <span
        class="ui-selfie-capture__requirement"
        [class.ui-selfie-capture__requirement--error]="invalid() && required()"
        aria-hidden="true"
      >
        {{ requirementText() }}
      </span>
    }
  </div>

  @if (description()) {
    <p class="ui-selfie-capture__description" [id]="descriptionId()">
      {{ description() }}
    </p>
  }

  <button
    type="button"
    class="ui-selfie-capture__frame"
    [class.ui-selfie-capture__frame--invalid]="invalid()"
    [disabled]="disabled() || (cameraActive() && !cameraReady())"
    [attr.aria-label]="hasPreview() ? retakeLabel() : buttonLabel()"
    (click)="onPrimaryAction(selfieInput)"
  >
    @if (previewSrc()) {
      <img
        class="ui-selfie-capture__preview"
        [src]="previewSrc()!"
        [alt]="previewAlt()"
      />
    } @else if (isCameraMode() && cameraActive() && !captureInDrawer()) {
      <video
        #cameraVideo
        class="ui-selfie-capture__video"
        autoplay
        muted
        playsinline
      ></video>
    } @else {
      <div class="ui-selfie-capture__placeholder" aria-hidden="true">
        <span
          class="ui-selfie-capture__icon"
          [style.--ui-selfie-capture-icon-src]="'url(' + iconSrc() + ')'"
          aria-hidden="true"
        ></span>
        <span>{{ placeholder() }}</span>
      </div>
    }
  </button>

  <input
    #selfieInput
    class="ui-selfie-capture__input"
    type="file"
    [id]="inputId()"
    [accept]="accept()"
    [attr.capture]="captureAttr()"
    [disabled]="disabled()"
    [attr.aria-describedby]="ariaDescribedBy()"
    [attr.aria-invalid]="invalid() ? 'true' : null"
    [attr.aria-required]="required() ? 'true' : null"
    (change)="onFileChange($event)"
  />

  <div class="ui-selfie-capture__actions">
    <button
      type="button"
      class="ui-selfie-capture__action ui-selfie-capture__action--primary"
      [disabled]="disabled() || (cameraActive() && !cameraReady())"
      (click)="onPrimaryAction(selfieInput)"
    >
      {{ primaryActionLabel() }}
    </button>

    @if (hasPreview()) {
      <button
        type="button"
        class="ui-selfie-capture__action ui-selfie-capture__action--ghost"
        [disabled]="disabled()"
        (click)="clearSelfie()"
      >
        {{ clearLabel() }}
      </button>
    }
  </div>

  @if (cameraError()) {
    <p class="ui-selfie-capture__message" role="alert">
      {{ cameraError() }}
    </p>
  }

  @if (message() && invalid() && showMessage()) {
    <p
      class="ui-selfie-capture__message"
      [id]="messageId()"
      role="alert"
    >
      {{ message() }}
    </p>
  }
</div>

@if (captureInDrawer()) {
  <ui-drawer
    [open]="cameraDrawerOpen()"
    (openChange)="onCameraDrawerOpenChange($event)"
    [title]="cameraDrawerTitle()"
    placement="center"
    cancelLabel="Cancelar"
    [showSaveButton]="false"
  >
    <div class="ui-selfie-capture__camera-drawer">
      <div class="ui-selfie-capture__camera-stage">
        @if (cameraActive()) {
          <video
            #cameraVideo
            class="ui-selfie-capture__camera-video"
            autoplay
            muted
            playsinline
          ></video>
        } @else if (cameraError()) {
          <p class="ui-selfie-capture__camera-error" role="alert">
            {{ cameraError() }}
          </p>
        }
      </div>

      <div class="ui-selfie-capture__camera-actions">
        <button
          type="button"
          class="ui-selfie-capture__action ui-selfie-capture__action--primary"
          [disabled]="!cameraReady()"
          (click)="captureFromDrawer()"
        >
          {{
            captureInProgress()
              ? processingLabel()
              : cameraReady()
                ? captureLabel()
                : focusingLabel()
          }}
        </button>
      </div>
    </div>
  </ui-drawer>
}
